var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucherUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1056_1011)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1056_1011",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0.279297H0.5V20.2793H20.5V0.279297Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1056_1011)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 0.279297C5.46804 0.279297 3.41602 2.33132 3.41602 4.86263C3.41602 7.39394 5.46804 9.44597 7.99935 9.44597C10.5307 9.44597 12.5827 7.39394 12.5827 4.86263C12.5827 2.33132 10.5307 0.279297 7.99935 0.279297ZM5.08268 4.86263C5.08268 3.2518 6.38852 1.94596 7.99935 1.94596C9.61018 1.94596 10.916 3.2518 10.916 4.86263C10.916 6.47346 9.61018 7.7793 7.99935 7.7793C6.38852 7.7793 5.08268 6.47346 5.08268 4.86263Z",
    fill: "#EB662B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4173 0.279297C12.9571 0.279297 12.584 0.652393 12.584 1.11263C12.584 1.57286 12.9571 1.94596 13.4173 1.94596C15.0282 1.94596 16.334 3.2518 16.334 4.86263C16.334 6.47346 15.0282 7.7793 13.4173 7.7793C12.9571 7.7793 12.584 8.15239 12.584 8.61263C12.584 9.07288 12.9571 9.44597 13.4173 9.44597C15.9487 9.44597 18.0006 7.39394 18.0006 4.86263C18.0006 2.33132 15.9487 0.279297 13.4173 0.279297Z",
    fill: "#EB662B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4039 11.9591C16.5882 11.5373 17.0794 11.3448 17.5012 11.5291C19.2654 12.2998 20.5009 14.061 20.5009 16.1127V17.7793C20.5009 18.2396 20.1278 18.6127 19.6675 18.6127C19.2073 18.6127 18.8342 18.2396 18.8342 17.7793V16.1127C18.8342 14.7471 18.0129 13.5714 16.8339 13.0563C16.4121 12.8721 16.2196 12.3807 16.4039 11.9591Z",
    fill: "#EB662B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.1123C2.73857 11.1123 0.5 13.3509 0.5 16.1123V17.779C0.5 18.2392 0.873096 18.6123 1.33333 18.6123C1.79357 18.6123 2.16667 18.2392 2.16667 17.779V16.1123C2.16667 14.2714 3.65905 12.779 5.5 12.779H10.5C12.3409 12.779 13.8333 14.2714 13.8333 16.1123V17.779C13.8333 18.2392 14.2064 18.6123 14.6667 18.6123C15.1269 18.6123 15.5 18.2392 15.5 17.779V16.1123C15.5 13.3509 13.2614 11.1123 10.5 11.1123H5.5Z",
    fill: "#EB662B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1056_1011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.279297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherUserIcon);
export default __webpack_public_path__ + "static/media/voucher-user-icon.c839ff171bf0841c88f5b1624adfb959.svg";
export { ForwardRef as ReactComponent };